import { useAppSelector } from 'hooks/reduxHooks'
import useCruiseInternationalMarket from 'hooks/useCruiseInternationalMarket'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

export enum CruisePageContentSection {
  Deals = 'deals',
  TopOffers = 'topOffers',
  LuxPlusOffers = 'luxPlusOffers',
  CruiseLines = 'cruiseLines',
  Destinations = 'destinations',
  DepartingFrom = 'departingFrom',
  RoyalCaribbean = 'royalCaribbean',
  Departures = 'departures',
  ShortTerm = 'shortTerm',
  LongHaulOcean = 'longHaulOcean',
  LuxuryPremium = 'luxuryPremium',
  River = 'river',
  BestValue = 'bestValue',
  Expedition = 'expedition',
  CruiseTour = 'cruiseTour',
  Banners = 'banners',
  WhyBookWithUs = 'whyBookWithUs',
  Support = 'support',
}

const CRUISE_PAGE_MEMBER_CONTENT_ORDER: Array<CruisePageContentSection> = [
  CruisePageContentSection.Deals,
  CruisePageContentSection.TopOffers,
  CruisePageContentSection.LuxPlusOffers,
  CruisePageContentSection.Destinations,
  CruisePageContentSection.DepartingFrom,
  CruisePageContentSection.Departures,
  CruisePageContentSection.LongHaulOcean,
  CruisePageContentSection.River,
  CruisePageContentSection.RoyalCaribbean,
  CruisePageContentSection.Banners,
  CruisePageContentSection.WhyBookWithUs,
  CruisePageContentSection.BestValue,
  CruisePageContentSection.LuxuryPremium,
  CruisePageContentSection.ShortTerm,
  CruisePageContentSection.Support,
  CruisePageContentSection.CruiseLines,
  CruisePageContentSection.Expedition,
  CruisePageContentSection.CruiseTour,
]

const CRUISE_PAGE_NON_MEMBER_CONTENT_ORDER: Array<CruisePageContentSection> = [
  CruisePageContentSection.Deals,
  CruisePageContentSection.TopOffers,
  CruisePageContentSection.Destinations,
  CruisePageContentSection.DepartingFrom,
  CruisePageContentSection.Departures,
  CruisePageContentSection.LongHaulOcean,
  CruisePageContentSection.River,
  CruisePageContentSection.LuxPlusOffers,
  CruisePageContentSection.RoyalCaribbean,
  CruisePageContentSection.Banners,
  CruisePageContentSection.WhyBookWithUs,
  CruisePageContentSection.BestValue,
  CruisePageContentSection.LuxuryPremium,
  CruisePageContentSection.ShortTerm,
  CruisePageContentSection.Support,
  CruisePageContentSection.CruiseLines,
  CruisePageContentSection.Expedition,
  CruisePageContentSection.CruiseTour,
]

const CRUISE_PAGE_INTERNATIONAL_CONTENT_ORDER: Array<CruisePageContentSection> = [
  CruisePageContentSection.TopOffers,
  CruisePageContentSection.Destinations,
  CruisePageContentSection.DepartingFrom,
  CruisePageContentSection.Departures,
  CruisePageContentSection.WhyBookWithUs,
  CruisePageContentSection.LuxuryPremium,
  CruisePageContentSection.Expedition,
]

interface CruisePageContentOrderOptions {
  isLuxPlusMember: boolean
  isInternationalMarket: boolean
}

export function getCruisePageContentOrder({
  isLuxPlusMember,
  isInternationalMarket,
}: CruisePageContentOrderOptions): Array<CruisePageContentSection> {
  if (isInternationalMarket) {
    return CRUISE_PAGE_INTERNATIONAL_CONTENT_ORDER
  }

  return isLuxPlusMember ?
    CRUISE_PAGE_MEMBER_CONTENT_ORDER :
    CRUISE_PAGE_NON_MEMBER_CONTENT_ORDER
}

export default function useCruisePageContentOrder(): Array<CruisePageContentSection> {
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)
  const isInternationalMarket = useCruiseInternationalMarket()

  return getCruisePageContentOrder({
    isLuxPlusMember,
    isInternationalMarket,
  })
}
